import axios from 'axios'

import { baseUrlFrontApi } from '~/js/templates/index/helpers'
import { ID_DATA } from '~/js/constants/data-element-ids'

const CLASS_NAME_TRIGGER_MARK_AS_USED = 'js-triggerMarkAsUsed'
const CLASS_NAME_TRIGGER_SHOW_CONTENT = 'js-triggerShowContent'
const CLASS_NAME_TRIGGER_SHOW_CODE = 'js-triggerShowCode'
const CLASS_NAME_COPY_CODE = 'js-copyCode'

document.addEventListener('DOMContentLoaded', () => {
  const elementsTriggerMarkAsUsed = document.getElementsByClassName(
    CLASS_NAME_TRIGGER_MARK_AS_USED
  )
  if (elementsTriggerMarkAsUsed.length) {
    Array.from(elementsTriggerMarkAsUsed).forEach((element) => {
      element.addEventListener('click', async () => {
        if (!confirm('クーポン使用済みにします。よろしいですか？')) return

        const code = element.dataset.code
        const handle = element.dataset.handle
        const dataElement = document.getElementById(ID_DATA)
        const customerId = dataElement.dataset.customerId
        const h = dataElement.dataset.hashedCustomerId

        try {
          await axios.post(`${baseUrlFrontApi}/add-used-discount-code`, {
            customerId,
            code,
            h,
          })
          const elementTargetRemove = document.getElementById(
            `js-targetRemove-${handle}`
          )
          elementTargetRemove.remove()

          const elementTextNotAvailable = document.getElementById(
            `js-textNotAvailable-${handle}`
          )
          elementTextNotAvailable.classList.add('is-not-available')
        } catch (error) {
          alert(`エラーがありました。\n${error}`)
        }
      })
    })
  }

  const elementsTriggerShowContent = document.getElementsByClassName(
    CLASS_NAME_TRIGGER_SHOW_CONTENT
  )
  if (elementsTriggerShowContent.length) {
    Array.from(elementsTriggerShowContent).forEach((element) => {
      const idContent = element.dataset.idContent
      const elementContent = document.getElementById(idContent)
      elementContent.classList.add('is-hidden')
      element.addEventListener('click', () => {
        element.classList.toggle('is-open')
        elementContent.classList.toggle('is-hidden')
      })
    })
  }

  const elementsTriggerShowCode = document.getElementsByClassName(
    CLASS_NAME_TRIGGER_SHOW_CODE
  )
  if (elementsTriggerShowCode.length) {
    Array.from(elementsTriggerShowCode).forEach((element) => {
      const target = element.dataset.target
      const elementCode = document.getElementById(target)
      const idTargetHide = element.dataset.targetHide
      const elementTargetHide = document.getElementById(idTargetHide)
      element.addEventListener('click', () => {
        elementCode.classList.add('is-show')
        if (elementTargetHide) {
          elementTargetHide.classList.remove('is-show')
          elementTargetHide.classList.add('is-hidden')
        }
      })
    })
  }

  const elementsCopyCode = document.getElementsByClassName(CLASS_NAME_COPY_CODE)
  if (elementsCopyCode.length) {
    Array.from(elementsCopyCode).forEach((element) => {
      const elementButtonCopyCode = element.querySelector('button')
      const elementInput = element.querySelector('input')
      if (!elementButtonCopyCode || !elementInput) return
      elementButtonCopyCode.addEventListener('click', () => {
        if (navigator.clipboard) {
          const text = elementInput.value
          navigator.clipboard.writeText(text)
        } else {
          elementInput.select()
          document.execCommand('copy')
        }
        alert('クーポンコードをコピーしました。')
      })
    })
  }
})
